import { PROFILE_ROUTE_NAMES } from '../../../constants/route'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewDocFlowRow } from '../BirdviewDocFlowRow'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

function BirdviewDocFlowsWidget({
  dragHandleProps,
  info,
  section,
  title,
  onNavigate,
}) {
  const { getListTarget } = useBirdviewListTarget()

  function handleOpen({ event, item }) {
    onNavigate({ event, link: PROFILE_ROUTE_NAMES.docFlow(item.id) })
  }

  function handleShowAll(event) {
    onNavigate({
      event,
      link: getListTarget(BIRDVIEW_SECTION_TARGET.docFlows),
    })
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      info={info}
      isRefreshing={section.isRefreshing}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewDocFlowRow item={item} key={item.id} onOpen={handleOpen} />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewDocFlowsWidget
